import { isPendingConfirmationReplyOnlyEnabled } from '../../../config/featureFlags';

export const CHECK_IN_SMS_DEFAULT =
  'Hi {{customerName}}, your {{service}} appointment is on {{date}} at {{time}}. Check in when you arrive: {{checkInUrl}}';

const PENDING_CONFIRMATION_DEFAULT = isPendingConfirmationReplyOnlyEnabled()
  ? 'Hi {{customerName}}, please confirm your appointment for {{service}} on {{date}} at {{time}}.'
  : 'Hi {{customerName}}, please confirm your appointment for {{service}} on {{date}} at {{time}}. Confirm here: {{confirmUrl}}';

export const defaultTemplates = {
  notifications: {
    bookingConfirmation: false,
    appointmentReminders: false,
    schedulingUpdates: false,
    pendingConfirmationRequest: false,
    checkInLinkRequest: false
  },
  pendingConfirmationUseReply: isPendingConfirmationReplyOnlyEnabled(),
  templates: {
    bookingConfirmation: {
      content:
        'Hi {{customerName}}, your appointment for {{service}} has been confirmed for {{date}} at {{time}}. We look forward to seeing you!'
    },
    scheduleChange: {
      content:
        'Hi {{customerName}}, your appointment has been rescheduled.\nOld: {{oldDate}} at {{oldTime}}\nNew: {{newDate}} at {{newTime}}\nService: {{service}}'
    },
    appointmentReminder: {
      content:
        'Hi {{customerName}}, this is a reminder about your appointment for {{service}} tomorrow at {{time}}. We look forward to seeing you!'
    },
    pendingConfirmationRequest: {
      content: PENDING_CONFIRMATION_DEFAULT
    },
    checkInLinkRequest: {
      content: CHECK_IN_SMS_DEFAULT
    }
  },
  reminderEnabled: false,
  reminders: [
    {
      type: 'sms',
      timing: 24,
      enabled: false
    }
  ]
};

const mergeTemplate = (templateKey, savedTemplates = {}) => {
  const defaultTemplate = defaultTemplates.templates[templateKey];
  const saved = savedTemplates[templateKey] || {};
  const content =
    typeof saved.content === 'string' && saved.content.trim().length > 0
      ? saved.content
      : defaultTemplate?.content || '';

  return {
    ...defaultTemplate,
    ...saved,
    content
  };
};

export const mergeSMSSettingsWithDefaults = (settings = {}) => {
  const savedTemplates = settings?.templates || {};
  const templateKeys = new Set([
    ...Object.keys(defaultTemplates.templates),
    ...Object.keys(savedTemplates)
  ]);

  const templates = Array.from(templateKeys).reduce(
    (merged, templateKey) => ({
      ...merged,
      [templateKey]: mergeTemplate(templateKey, savedTemplates)
    }),
    {}
  );

  return {
    ...defaultTemplates,
    ...settings,
    pendingConfirmationUseReply: isPendingConfirmationReplyOnlyEnabled()
      ? true
      : typeof settings?.pendingConfirmationUseReply === 'boolean'
        ? settings.pendingConfirmationUseReply
        : defaultTemplates.pendingConfirmationUseReply,
    notifications: {
      bookingConfirmation:
        typeof settings?.notifications?.bookingConfirmation === 'boolean'
          ? settings.notifications.bookingConfirmation
          : defaultTemplates.notifications.bookingConfirmation,
      appointmentReminders:
        typeof settings?.notifications?.appointmentReminders === 'boolean'
          ? settings.notifications.appointmentReminders
          : defaultTemplates.notifications.appointmentReminders,
      schedulingUpdates:
        typeof settings?.notifications?.schedulingUpdates === 'boolean'
          ? settings.notifications.schedulingUpdates
          : defaultTemplates.notifications.schedulingUpdates,
      pendingConfirmationRequest:
        typeof settings?.notifications?.pendingConfirmationRequest === 'boolean'
          ? settings.notifications.pendingConfirmationRequest
          : defaultTemplates.notifications.pendingConfirmationRequest,
      checkInLinkRequest:
        typeof settings?.notifications?.checkInLinkRequest === 'boolean'
          ? settings.notifications.checkInLinkRequest
          : defaultTemplates.notifications.checkInLinkRequest,
    },
    templates
  };
};
